import styles from './license.module.css';
import { toSurePartUrl } from '../../surepart-routing';

class LicenseView extends HTMLElement {
    public connectedCallback(): void {
        this.render();
    }

    public render(): void {
        this.innerHTML = `
            <div class="${styles.licensePage}" data-testid="license-issue">
                <p>
                    Sorry, your company is not licensed to upload claims to SurePart for the insurer on this estimate.
                </p>
                <a href="${toSurePartUrl('/')}" data-testid="button" type="button" class="${styles.buttonSecondary}">
                    <span data-testid="button-text">Back to Claims</span>
                    <span aria-hidden="true" data-testid="button-icon-right" tabindex="-1">
                        <svg viewBox="0 0 24 24" fill="none" width="16" height="16" data-testid="arrow-left-icon"><path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        <div class="${styles.hidden}">Decorative icon</div>
                    </span>
                </a>
            </div>
        `;
    }
}

// Register the custom element
customElements.define('license-view', LicenseView);

export { LicenseView };
